import { render, staticRenderFns } from "./ExpansionLists.vue?vue&type=template&id=b3803cde&"
import script from "./ExpansionLists.vue?vue&type=script&lang=js&"
export * from "./ExpansionLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports